/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskList } from './taskList';


import {ValidatorFn, Validators} from "@angular/forms";

export interface PaginatedTaskListList { 
    next?: string | null;
    previous?: string | null;
    results: Array<TaskList>;
}
export const PaginatedTaskListList_next_Validators: ValidatorFn[] =
    [ ];

export const PaginatedTaskListList_previous_Validators: ValidatorFn[] =
    [ ];

export const PaginatedTaskListList_results_Validators: ValidatorFn[] =
    [  Validators.required, ];


